'use client';

import { type FC, type ReactNode, useMemo, useState } from 'react';
import { type Algorithms, ProgressContext } from './context';
type Props = {
  children: ReactNode;
  total?: number;
  algorithm?: Algorithms;
};
const ALGORITHMS: Record<Algorithms, (x: number) => number> = {
  linear: x => x,
  'ease-out-sine': x => Math.sin(x * Math.PI / 2)
};
const calcPercent = (current: number, total: number) => 100 * current / total;
export const ProgressProvider: FC<Props> = props => {
  const {
    total = 100,
    algorithm = 'linear'
  } = props;
  const [current, setCurrent] = useState<number>(0);
  const percent = useMemo(() => {
    if (current === 0) {
      return 0;
    }
    const algorithmFn = ALGORITHMS[algorithm];
    const x = calcPercent(current - 1, total) / 100;
    const futurePercent = Math.floor(algorithmFn(x) * 100);
    return futurePercent;
  }, [current, total, algorithm]);
  return <ProgressContext.Provider value={{
    percent,
    setCurrent,
    total,
    algorithm
  }} data-sentry-element="unknown" data-sentry-component="ProgressProvider" data-sentry-source-file="progress.provider.tsx">
      {props.children}
    </ProgressContext.Provider>;
};